// extracted by mini-css-extract-plugin
export default {"legendContainer":"legendContainer--mp-Y01oa","legendIcon":"legendIcon--mp-8xSaZ","partial":"partial--mp-yY_E8","legendCaption2":"legendCaption2--mp-Qt8E5"};